// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__12I0S","alertIcon":"ConfirmModal_alertIcon__24RIh"};